import { useEffect } from 'react';

const SITE = 'https://printablegraphpaperpdf.com';
const DEFAULT_IMAGE = SITE + '/og-image.png';

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.querySelector(`head meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setLinkCanonical(href) {
  const existing = document.querySelector('head link[rel="canonical"]');
  if (href === null) {
    if (existing) existing.remove();
    return;
  }
  if (!href) return;
  let el = existing;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function setRobots(content) {
  setMeta('name', 'robots', content);
}

function setJsonLd(jsonLd) {
  const ID = 'page-meta-jsonld';
  let el = document.getElementById(ID);
  if (!jsonLd) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('script');
    el.id = ID;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(jsonLd);
}

export function breadcrumbGraph(name, url) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE + '/' },
      { '@type': 'ListItem', position: 2, name, item: url },
    ],
  };
}

export default function usePageMeta({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogUrl,
  image,
  imageAlt,
  robots,
  jsonLd,
}) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);
    setMeta('property', 'og:title', ogTitle || title);
    setMeta('property', 'og:description', ogDescription || description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', ogUrl || canonical);
    setMeta('property', 'og:site_name', 'Printable Graph Paper');
    setMeta('property', 'og:locale', 'en_US');
    setMeta('property', 'og:image', image || DEFAULT_IMAGE);
    setMeta('property', 'og:image:alt', imageAlt || ogTitle || title);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', ogTitle || title);
    setMeta('name', 'twitter:description', ogDescription || description);
    setMeta('name', 'twitter:image', image || DEFAULT_IMAGE);
    setRobots(robots || 'index, follow');
    setLinkCanonical(canonical);
    setJsonLd(jsonLd);
  }, [
    title,
    description,
    keywords,
    canonical,
    ogTitle,
    ogDescription,
    ogUrl,
    image,
    imageAlt,
    robots,
    jsonLd,
  ]);
}
